import { Box, Button, RadioGroup, Text } from "@radix-ui/themes";
import { Control, Controller, FieldErrors,FieldValues, Path } from "react-hook-form";
import styles from './RadioGroupComponent.module.scss';
import { Cross2Icon } from "@radix-ui/react-icons";
interface RadioGroupProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: any;
  fieldProps?: any;
  options: { value: string, label: string }[],
  itemsLoading?: boolean;
  itemsError?: boolean;
  composedName?: { parent: any, prop: any }
  required?: boolean;
}

const RadioGroupComponent =<T extends FieldValues> ({ name, label, control, errors, style, fieldProps, options, composedName, itemsError, itemsLoading, required }: RadioGroupProps<T>) => {
  const castedErrors = errors as Record<string, any>;

  const composedError = composedName && composedName.parent && composedName.prop
    ? castedErrors?.[composedName.parent]?.[composedName.prop]
    : undefined;

  return <Box {...style} >
    <Text as="label" size="2" className={styles.label}>{<span>{label} {required && <span style={{ color: 'red' }}>*</span>}</span>}</Text>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
        <RadioGroup.Root variant="surface" name={field.name} onValueChange={field.onChange} value={`${field.value}` || ''} {...fieldProps}>
          {options.map((option) => {
            return (

              <RadioGroup.Item key={option.value} value={`${option.value}`}>{option.label}</RadioGroup.Item>

            )
          })}
            {field.value && !fieldProps?.disabled && (
                      <Button
                        variant="ghost"
                        size="1"
                        onClick={() => field.onChange("")}
                      >
                        <Cross2Icon />
                      </Button>
                    )}
        </RadioGroup.Root>
        </>
      )}
    />
    {composedError ? (
      <Text color="red" size="1">
        {composedError.message as string}
      </Text>
    ) : (
      errors?.[name] && (
        <Text color="red" size="1">
          {errors?.[name]?.message as string}
        </Text>
      )
    )}
  </Box>
};

export default RadioGroupComponent;
